import axios from 'axios';

export const api = axios.create({
    headers: {
        'Accept':           'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
});

/**
 * Zet een mislukt verzoek om in een melding en eventuele fouten per veld.
 *
 * @param {Error} error
 * @returns {{message: string, fields: Object<string, string>}}
 */
export function describeError(error) {
    const status = error.response?.status;

    if(status === 422) {
        const fields = {};
        Object.entries(error.response.data.errors || {}).forEach(([field, messages]) => fields[field] = messages[0]);

        // Fouten die niet bij een zichtbaar veld horen (antwoord op, honeypot, reCAPTCHA) komen in de algemene melding.
        const general = fields.parent_id || fields['g-recaptcha-response'] || fields.website || '';

        return {message: general, fields};
    }

    const messages = {
        403: 'Je mag dit niet (meer) doen. Ben je nog ingelogd in Atom?',
        404: 'Deze reactie of dit bericht bestaat niet meer. Ververs de pagina.',
        419: 'De pagina stond te lang open. Ververs de pagina en probeer het opnieuw.',
        429: 'Je plaatst wel heel snel reacties. Wacht even en probeer het dan opnieuw.'
    };

    return {message: messages[status] || 'Er ging iets mis. Probeer het later opnieuw.', fields: {}};
}
